import { gql, useMutation } from "@apollo/client";

const DELETE_HOMEOWNER_ACCOUNT_MUTATION = gql`
  mutation DeleteHomeownerAccount($homeownerId: ID!) {
    deleteHomeownerAccount(homeownerId: $homeownerId)
  }
`;

export const useDeleteHomeownerAccountMutation = () => {
  const [deleteHomeownerAccountMutation, { loading, error, data }] = useMutation(
    DELETE_HOMEOWNER_ACCOUNT_MUTATION
  );

  const deleteHomeownerAccount = async (homeownerId: string) => {
    try {
      const { data } = await deleteHomeownerAccountMutation({
        variables: { homeownerId },
      });
      return data?.deleteHomeownerAccount;
    } catch (error) {
      console.error("Error deleting homeowner account:", error);
      throw error;
    }
  };

  return { deleteHomeownerAccount, loading, error, data };
};
